import { useState, useEffect, Dispatch, SetStateAction} from "react";
import { IGUIElementController } from "../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsInterfaces";

interface IProps { 
  isEditing?: boolean
}

export interface IEditBaseControllerReturn extends IGUIElementController {
  
  //#region states
  isEditing: boolean; setIsEditing: Dispatch<SetStateAction<boolean>>;
  isDisabled: boolean;// setIsDisabled: Dispatch<SetStateAction<boolean>>;
  
  //hasDataToSubmit: boolean; setHasDataToSubmit: Dispatch<SetStateAction<boolean>>;
  isSubmitting: boolean; setIsSubmitting: (it: boolean) => void;

  //functions
  switchIsEditing:() => void
}

export const EditBaseController = (props: IProps): IEditBaseControllerReturn => {

    const tag = "EditBaseController";
    //console.log(tag + " START")
    
    //disabled
    const [isDisabled, setIsDisabled ] = useState<boolean>(true);
    
    //isSubmitting
    const [isSubmitting, _setIsSubmitting ] = useState<boolean>(false);
    const setIsSubmitting = (it: boolean) => { _setIsSubmitting(it); }
    useEffect(() => {
      if(isSubmitting) {
        //document.de
      }
    }, [isSubmitting]);
      
    //isEditing
    const [isEditing, setIsEditing] = useState<boolean>(props.isEditing?props.isEditing:false);
    useEffect(() => { 
      setIsDisabled(!isEditing) 
    }, [isEditing]);
    const switchIsEditing = () => { setIsEditing(!isEditing); }

    //modal
    const [showModal, setShowModal] = useState<boolean>(false);
    useEffect(() => { if(showModal == false) { setServerMessage(null); } }, [showModal]);

    const [serverMessage, setServerMessage] = useState<string | Nude>();  
    useEffect(() => { 
      if(serverMessage == null || serverMessage == undefined)  return;
      if(showModal == true) return;
      setShowModal(true) 
    }, [serverMessage]);

    //const [modalTitle, setModalTitle] = useState<string>();
    //#endregion


    //#region init
    useEffect(() => {
      setIsEditing(true) //inverted: Default ist true ->später dann beim geblockten Datensatz auf false setzen
      //setIsDisabled(true)
      //console.log(tag+  " => onMount()")
      return () => {
        //console.log(tag+  " <= unMount()")
      }
    }, []);
    //#endregion


    return {
      //#region states
      isSubmitting, setIsSubmitting,
      isEditing, setIsEditing,
      isDisabled,//setIsDisabled,

      //unassigned
      switchIsEditing,
      //#endregion
    }
}